module.exports = __webpack_public_path__ + "static/media/couponPertageimg.905c17a5.png";